import { defaultColors } from '../../../Common/Services/contexts/ServicesChartsDataContext';
import { PyramidChart } from '../../../Common/Charts/Pyramid';
import { useHomelessChartsDataContext } from './hooks/useHomelessChartsDataContext';

export const HomelessAndReltativesContact = () => {
    const { chartData } = useHomelessChartsDataContext();

    return (
        <PyramidChart
            title={'Pessoas em Situação de Rua - Contato com Parentes'}
            subtitles={
                chartData?.homelessAndReltativesContact?.map((item) => item.description) || []
            }
            values={chartData?.homelessAndReltativesContact?.map((item) => item.total  ||  0) || []}
            colors={defaultColors.slice(0, chartData?.homelessAndReltativesContact?.length) || []}
        />
    );
};
